import { render, staticRenderFns } from "./Self-hosting-the-web-interfaces.md?vue&type=template&id=6b52914a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports